module.exports = __webpack_public_path__ + "static/saw-2308dc61df8460dba6f31271980114a7.svg";